import {LANDING} from '@constants/internal-route.constant'
import {IAppRoutes} from '@interface/common.interface'
import {lazy} from 'react'
import {ChatAdminRoutes} from './chat-admin.routes'
import {ChatComplianceRoutes} from './chat-compliance.routes'
import {NotificationRoutes} from './notification.routes'
import LandingRedirect from '../LandingRedirect'

const Error404 = lazy(() => import('pages/errors/ErrorsPage'))

export const AppRouteList: IAppRoutes[] = [
  {
    // Not feature-guarded on purpose — every guard's fallback lands here (see LANDING).
    link: LANDING,
    element: lazy(() => import('pages/landing/Landing')),
  },
  ...ChatAdminRoutes,
  ...ChatComplianceRoutes,
  {...NotificationRoutes},
  {
    // The portal hand-off lands here: the role's landing page in this app, else LANDING.
    link: 'auth/*',
    element: LandingRedirect,
  },
  {
    link: '*',
    element: Error404,
  },
]
